import axios from 'axios'


var share = (url) => axios.get('http://212.64.24.247:3003/jssdk/wxconfig?url=' + url)



export { share }



// WEBPACK FOOTER //
// ./src/service/getData.js